import { useState } from "react";
import { Link } from "react-router-dom";
import AdminLayout from "../components/AdminLayout";

interface PinRecord {
  id: string;
  listingId: string;
  listingTitle: string;
  category: string;
  userName: string;
  userAvatar: string;
  planName: string;
  duration: string;
  price: number;
  startTime: string;
  endTime: string;
  status: "active" | "expired" | "cancelled";
  payMethod: "wechat" | "alipay";
}

const mockPinRecords: PinRecord[] = [
  {
    id: "pin001",
    listingId: "1",
    listingTitle: "专业企业网站开发，10年经验团队，响应式设计",
    category: "软件开发",
    userName: "张伟科技",
    userAvatar: "https://readdy.ai/api/search-image?query=professional%20male%20business%20avatar%20portrait%20clean%20background&width=40&height=40&seq=av1&orientation=squarish",
    planName: "7天置顶",
    duration: "7天",
    price: 25,
    startTime: "2026-04-20 10:30",
    endTime: "2026-04-27 10:30",
    status: "active",
    payMethod: "wechat",
  },
  {
    id: "pin002",
    listingId: "2",
    listingTitle: "品牌VI设计、LOGO设计，专业设计团队承接各类设计项目",
    category: "设计策划",
    userName: "创意设计工作室",
    userAvatar: "https://readdy.ai/api/search-image?query=creative%20female%20designer%20avatar%20portrait%20clean%20background&width=40&height=40&seq=av2&orientation=squarish",
    planName: "30天置顶",
    duration: "30天",
    price: 88,
    startTime: "2026-04-15 14:20",
    endTime: "2026-05-15 14:20",
    status: "active",
    payMethod: "alipay",
  },
  {
    id: "pin003",
    listingId: "3",
    listingTitle: "企业税务筹划、代理记账，专业财税团队服务",
    category: "财税法务",
    userName: "鑫诚财税",
    userAvatar: "https://readdy.ai/api/search-image?query=professional%20accountant%20avatar%20portrait%20clean%20background&width=40&height=40&seq=av3&orientation=squarish",
    planName: "3天置顶",
    duration: "3天",
    price: 12,
    startTime: "2026-04-22 09:00",
    endTime: "2026-04-25 09:00",
    status: "expired",
    payMethod: "wechat",
  },
  {
    id: "pin004",
    listingId: "4",
    listingTitle: "全网营销推广，SEO优化、信息流广告投放一站式服务",
    category: "营销推广",
    userName: "数字营销达人",
    userAvatar: "https://readdy.ai/api/search-image?query=marketing%20professional%20avatar%20portrait%20clean%20background&width=40&height=40&seq=av4&orientation=squarish",
    planName: "24小时置顶",
    duration: "24小时",
    price: 5,
    startTime: "2026-04-26 16:00",
    endTime: "2026-04-27 16:00",
    status: "active",
    payMethod: "alipay",
  },
  {
    id: "pin005",
    listingId: "5",
    listingTitle: "企业法律顾问服务，合同审查、纠纷处理、知识产权保护",
    category: "财税法务",
    userName: "律政先锋",
    userAvatar: "https://readdy.ai/api/search-image?query=lawyer%20professional%20avatar%20portrait%20clean%20background&width=40&height=40&seq=av5&orientation=squarish",
    planName: "7天置顶",
    duration: "7天",
    price: 25,
    startTime: "2026-04-10 11:00",
    endTime: "2026-04-17 11:00",
    status: "cancelled",
    payMethod: "wechat",
  },
  {
    id: "pin006",
    listingId: "6",
    listingTitle: "高端商业摄影、产品拍摄、企业宣传片制作",
    category: "设计策划",
    userName: "光影视觉",
    userAvatar: "https://readdy.ai/api/search-image?query=photographer%20creative%20avatar%20portrait%20clean%20background&width=40&height=40&seq=av6&orientation=squarish",
    planName: "30天置顶",
    duration: "30天",
    price: 88,
    startTime: "2026-04-01 08:00",
    endTime: "2026-05-01 08:00",
    status: "active",
    payMethod: "wechat",
  },
  {
    id: "pin007",
    listingId: "7",
    listingTitle: "人力资源外包、招聘代理、薪酬管理一体化解决方案",
    category: "人力资源",
    userName: "优才人力",
    userAvatar: "https://readdy.ai/api/search-image?query=HR%20professional%20avatar%20portrait%20clean%20background&width=40&height=40&seq=av7&orientation=squarish",
    planName: "3天置顶",
    duration: "3天",
    price: 12,
    startTime: "2026-04-18 13:30",
    endTime: "2026-04-21 13:30",
    status: "expired",
    payMethod: "alipay",
  },
];

const statusConfig = {
  active: { label: "置顶中", className: "bg-green-50 text-green-600" },
  expired: { label: "已到期", className: "bg-gray-100 text-gray-500" },
  cancelled: { label: "已取消", className: "bg-red-50 text-red-500" },
};

const payMethodConfig = {
  wechat: { label: "微信支付", icon: "ri-wechat-pay-fill", color: "text-green-500" },
  alipay: { label: "支付宝", icon: "ri-alipay-fill", color: "text-sky-500" },
};

function getRemainingTime(endTime: string): string {
  const end = new Date(endTime).getTime();
  const now = Date.now();
  const diff = end - now;
  if (diff <= 0) return "已到期";
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  if (days > 0) return `剩余 ${days}天${hours}小时`;
  return `剩余 ${hours}小时`;
}

export default function AdminPinManagementPage() {
  const [records, setRecords] = useState<PinRecord[]>(mockPinRecords);
  const [filterStatus, setFilterStatus] = useState<"all" | "active" | "expired" | "cancelled">("all");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [confirmCancel, setConfirmCancel] = useState<string | null>(null);

  const filtered = records.filter((r) => {
    const matchStatus = filterStatus === "all" || r.status === filterStatus;
    const matchSearch =
      !searchKeyword ||
      r.listingTitle.includes(searchKeyword) ||
      r.userName.includes(searchKeyword);
    return matchStatus && matchSearch;
  });

  const handleCancel = (id: string) => {
    setRecords((prev) =>
      prev.map((r) => (r.id === id ? { ...r, status: "cancelled" } : r))
    );
    setConfirmCancel(null);
  };

  const stats = {
    total: records.length,
    active: records.filter((r) => r.status === "active").length,
    expired: records.filter((r) => r.status === "expired").length,
    revenue: records.filter((r) => r.status !== "cancelled").reduce((sum, r) => sum + r.price, 0),
  };

  return (
    <AdminLayout>
      <div className="space-y-5">
        {/* Header */}
        <div>
          <h1 className="text-xl font-bold text-gray-800">置顶管理</h1>
          <p className="text-sm text-gray-500 mt-1">管理所有置顶帖子，查看置顶时间和到期状态</p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-4 gap-4">
          {[
            { label: "置顶总数", value: stats.total, icon: "ri-pushpin-line", color: "text-orange-500", bg: "bg-orange-50" },
            { label: "置顶中", value: stats.active, icon: "ri-checkbox-circle-line", color: "text-green-500", bg: "bg-green-50" },
            { label: "已到期", value: stats.expired, icon: "ri-time-line", color: "text-gray-500", bg: "bg-gray-100" },
            { label: "置顶收入", value: `¥${stats.revenue}`, icon: "ri-money-cny-circle-line", color: "text-orange-500", bg: "bg-orange-50" },
          ].map((stat) => (
            <div key={stat.label} className="bg-white rounded-xl border border-gray-100 p-4 flex items-center gap-3">
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${stat.bg} shrink-0`}>
                <i className={`${stat.icon} ${stat.color} text-lg`} />
              </div>
              <div>
                <div className="text-xs text-gray-500">{stat.label}</div>
                <div className="text-xl font-bold text-gray-800 mt-0.5">{stat.value}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Filters */}
        <div className="bg-white rounded-xl border border-gray-100 p-4 flex items-center gap-4 flex-wrap">
          <div className="flex items-center gap-1 p-1 bg-gray-100 rounded-lg">
            {(["all", "active", "expired", "cancelled"] as const).map((s) => (
              <button
                key={s}
                onClick={() => setFilterStatus(s)}
                className={`px-3 py-1.5 text-xs rounded-md transition-colors cursor-pointer whitespace-nowrap ${
                  filterStatus === s ? "bg-white text-gray-800 font-medium" : "text-gray-500 hover:text-gray-700"
                }`}
              >
                {s === "all" ? "全部" : statusConfig[s].label}
              </button>
            ))}
          </div>
          <div className="flex-1 min-w-48">
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
              <input
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
                placeholder="搜索帖子标题或用户名..."
                className="w-full pl-8 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:border-orange-400"
              />
            </div>
          </div>
          <div className="text-xs text-gray-400 ml-auto">共 {filtered.length} 条记录</div>
        </div>

        {/* Table */}
        <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-100 bg-gray-50">
                  <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 whitespace-nowrap">帖子信息</th>
                  <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 whitespace-nowrap">发布用户</th>
                  <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 whitespace-nowrap">套餐</th>
                  <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 whitespace-nowrap">置顶时间</th>
                  <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 whitespace-nowrap">到期时间</th>
                  <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 whitespace-nowrap">剩余时间</th>
                  <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 whitespace-nowrap">支付</th>
                  <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 whitespace-nowrap">状态</th>
                  <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 whitespace-nowrap">操作</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((record) => (
                  <tr key={record.id} className="border-b border-gray-50 hover:bg-gray-50/50 transition-colors">
                    <td className="px-4 py-3">
                      <div className="max-w-[220px]">
                        <Link
                          to={`/listing/${record.listingId}`}
                          target="_blank"
                          className="text-sm text-gray-800 hover:text-orange-500 transition-colors line-clamp-2 leading-snug"
                        >
                          {record.listingTitle}
                        </Link>
                        <span className="inline-block mt-1 px-1.5 py-0.5 bg-orange-50 text-orange-500 text-xs rounded-full">{record.category}</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2">
                        <div className="w-7 h-7 rounded-full overflow-hidden bg-gray-100 shrink-0">
                          <img src={record.userAvatar} alt={record.userName} className="w-full h-full object-cover" />
                        </div>
                        <span className="text-sm text-gray-700 whitespace-nowrap">{record.userName}</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <div>
                        <div className="text-sm font-medium text-gray-800 whitespace-nowrap">{record.planName}</div>
                        <div className="text-xs text-orange-500 font-semibold">¥{record.price}</div>
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <span className="text-xs text-gray-600 whitespace-nowrap">{record.startTime}</span>
                    </td>
                    <td className="px-4 py-3">
                      <span className="text-xs text-gray-600 whitespace-nowrap">{record.endTime}</span>
                    </td>
                    <td className="px-4 py-3">
                      {record.status === "active" ? (
                        <span className="text-xs font-medium text-green-600 whitespace-nowrap">{getRemainingTime(record.endTime)}</span>
                      ) : (
                        <span className="text-xs text-gray-400">—</span>
                      )}
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-1 whitespace-nowrap">
                        <div className="w-4 h-4 flex items-center justify-center">
                          <i className={`${payMethodConfig[record.payMethod].icon} ${payMethodConfig[record.payMethod].color} text-sm`} />
                        </div>
                        <span className="text-xs text-gray-500">{payMethodConfig[record.payMethod].label}</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <span className={`px-2 py-1 text-xs rounded-full whitespace-nowrap ${statusConfig[record.status].className}`}>
                        {statusConfig[record.status].label}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2">
                        <Link
                          to={`/listing/${record.listingId}`}
                          target="_blank"
                          className="px-2.5 py-1 text-xs border border-gray-200 text-gray-600 rounded-lg hover:border-orange-400 hover:text-orange-500 cursor-pointer whitespace-nowrap transition-colors"
                        >
                          查看
                        </Link>
                        {record.status === "active" && (
                          <button
                            onClick={() => setConfirmCancel(record.id)}
                            className="px-2.5 py-1 text-xs border border-gray-200 text-gray-600 rounded-lg hover:border-red-300 hover:text-red-500 cursor-pointer whitespace-nowrap transition-colors"
                          >
                            取消置顶
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {filtered.length === 0 && (
            <div className="py-16 text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-gray-100 rounded-full">
                <i className="ri-pushpin-line text-xl text-gray-400" />
              </div>
              <p className="text-sm text-gray-400">暂无置顶记录</p>
            </div>
          )}
        </div>
      </div>

      {/* Confirm Cancel Modal */}
      {confirmCancel && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" onClick={() => setConfirmCancel(null)}>
          <div className="bg-white rounded-2xl w-full max-w-sm shadow-xl" onClick={(e) => e.stopPropagation()}>
            <div className="p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center bg-red-50 rounded-full">
                <i className="ri-error-warning-line text-red-500 text-xl" />
              </div>
              <h3 className="font-semibold text-gray-800 mb-2">确认取消置顶？</h3>
              <p className="text-sm text-gray-500">取消后该帖子将立即从置顶位置移除，此操作不可撤销。</p>
            </div>
            <div className="flex gap-3 px-6 pb-6">
              <button onClick={() => setConfirmCancel(null)} className="flex-1 py-2.5 text-sm border border-gray-200 rounded-xl hover:bg-gray-50 cursor-pointer">
                取消
              </button>
              <button
                onClick={() => handleCancel(confirmCancel)}
                className="flex-1 py-2.5 text-sm bg-red-500 text-white rounded-xl hover:bg-red-600 cursor-pointer"
              >
                确认取消
              </button>
            </div>
          </div>
        </div>
      )}
    </AdminLayout>
  );
}
